import type { MonetatePayload } from '@johnlewispartnership/wtr-website-decisioner-client/types/MonetateTypes';
import React from 'react';

export type ExperimentView = {
  id: string;
  variant: string;
  trackAll?: boolean;
};

type GetExperimentByIdOptions = {
  manualTracking: boolean;
};

export type TrackedExperimentsContextValue = {
  getExperimentById: (
    id: string,
    options?: GetExperimentByIdOptions,
  ) => {
    variant: string;
    payload: MonetatePayload | undefined;
    experienceLabel: string | undefined;
    variantLabel: string | undefined;
    trackExperimentView: (trackAll?: boolean) => void;
  };
  trackExperimentViewEvent: (view: ExperimentView) => void;
};

const TrackedExperimentsContext = React.createContext<TrackedExperimentsContextValue | undefined>(
  undefined,
);

export default TrackedExperimentsContext;
